import { IntegrationType } from 'src/generated/mloop-graphql';

import { ApiVerb, apiPost } from 'src/utils/api';

import {
  AshbyIntegration,
  BrighthireStoreIntegration,
  CodeSignalIntegration,
  CoderPadIntegration,
  CodilityIntegration,
  GemIntegration,
  GoogleIntegration,
  HackerRankIntegration,
  MicrosoftServiceUserStoreIntegration,
  MultiDomainIntegration,
  SmartRecruitersIntegration,
  WorkdayIntegration,
} from './types';

interface StoreIntegrationRequest {
  integration_type: IntegrationType;
  skip_hook?: boolean;
  coderpad?: CoderPadIntegration;
  codesignal?: CodeSignalIntegration;
  ashby?: AshbyIntegration;
  codility?: CodilityIntegration;
  hackerrank?: HackerRankIntegration;
  google?: GoogleIntegration;
  gem?: GemIntegration;
  workday?: WorkdayIntegration;
  brighthire?: BrighthireStoreIntegration;
  smartRecruiters?: SmartRecruitersIntegration;
  multiDomain?: MultiDomainIntegration;
  microsoft_service_user?: MicrosoftServiceUserStoreIntegration;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function putIntegration(data: StoreIntegrationRequest): Promise<any> {
  const response = await apiPost(ApiVerb.PUT_INTEGRATION, data);
  return response.data;
}
